module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0060.jpg?v=e56c425a";